import React from "react";
import Report from "../components/report/Report";
import { useContext } from "react";
import { AuthContext } from "../util/authContext";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import IdleWrapper from "../components/auth/IdleWrapper";

export default function ReportPage() {
  const ctx = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!ctx.isLoggedIn) {
      navigate("/login");
      return;
    }
  }, [ctx.isLoggedIn, navigate]);
  return <IdleWrapper><Report /> </IdleWrapper> ;
}
